import { FilesContainer } from 'modules/files';
import type { LeadCloudFileType } from '@econtractor/types';

interface TaskCardFilesProps {
    taskId: number;
    files: LeadCloudFileType[];
}

const TaskCardFiles = ({ taskId, files }: TaskCardFilesProps) => {
    if (!Array.isArray(files) || !files.length) return null;

    return (
        <FilesContainer
            files={files}
            scope={{ taskId: Number(taskId || 0) }}
            imageColProps={{ xs: 6, md: 4 }}
            canEdit={false}
            addButtonLabel=""
            uploadingLabel=""
            saveFirstMessage=""
            errorMessage=""
            uploadSuccessMessage=""
            onFilesChange={async () => true}
        />
    );
};

export default TaskCardFiles;
